import { useEffect, useState } from 'react'

import { Establishment } from '@/core/api/modules/establishment/types'
import api from '@/lib/api'

export const useGetEstablishments = () => {
    const [establishments, setEstablishments] = useState<Establishment[]>([])

    useEffect(() => {
        const fetchEstablishments = async () => {
            try {
                const data = await api.establishment.getJoinableEstablishments()
                setEstablishments(data)
            } catch (error) {
                console.error('Failed to fetch establishments', error)
            }
        }
        fetchEstablishments()
    }, [])

    return { establishments }
}
